export default __webpack_public_path__ + "static/media/ic_chevron_left_black_24px.f3e36b9d.svg";